export default "__VITE_ASSET__B0Us9xnz__"